export default function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Thompson',
      role: 'Homeowner',
      location: 'Richmond Hill',
      rating: 5,
      text: 'Mow and Snow has been taking care of our property for 3 years now. Their monthly plan is incredibly convenient and the team is always professional. Our lawn has never looked better!',
      image: 'https://public.readdy.ai/ai/img_res/a072afe67628aaf5e9b4ae44160045cf.jpg',
    },
    {
      name: 'Sarah Chen',
      role: 'Business Owner',
      location: 'Toronto',
      rating: 5,
      text: 'As a commercial property owner, having reliable year-round service is crucial. Their team handles everything from summer maintenance to winter snow clearing perfectly. Highly recommend!',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20asian%20woman%20business%20owner%20smiling%2C%20confident%20entrepreneur%2C%20modern%20business%20attire%2C%20bright%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=200&height=200&seq=testimonial-002&orientation=squarish',
    },
    {
      name: 'David Martinez',
      role: 'Residential Client',
      location: 'Whitby',
      rating: 5,
      text: 'The flat monthly rate is a game-changer. No more worrying about surprise bills or finding someone reliable for snow removal. They do it all and do it well. Five stars!',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20hispanic%20man%20smiling%20outdoors%2C%20happy%20homeowner%2C%20casual%20clothing%2C%20bright%20natural%20lighting%2C%20high%20quality%20professional%20photography&width=200&height=200&seq=testimonial-003&orientation=squarish',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-red-50 text-red-600 rounded-full text-sm font-semibold mb-4">
            Testimonials
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it – hear from the homeowners and businesses we serve
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, starIdx) => (
                  <i key={starIdx} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-4 pt-4 border-t border-gray-100">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-500">
                    {testimonial.role} • {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">500+</div>
            <div className="text-gray-600">Happy Clients</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">GTA's Trusted</div>
            <div className="text-gray-600">Landscaping Choice</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">5,000+</div>
            <div className="text-gray-600">Projects Completed</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-red-600 mb-2">100%</div>
            <div className="text-gray-600">Satisfaction Rate</div>
          </div>
        </div>
      </div>
    </section>
  );
}
